import React from 'react';
import './StarRating.css';

interface StarRatingProps {
  value: number | string;
  maxStars?: number;
}

const StarRating: React.FC<StarRatingProps> = ({ value, maxStars = 5 }) => {
  // Convert value to number
  const numericValue = typeof value === 'string' ? parseFloat(value) : value;
  
  // Return empty if value is invalid
  if (isNaN(numericValue) || numericValue < 0) {
    return <span className="star-rating-empty">-</span>;
  }

  const fullStars = Math.floor(numericValue);
  const hasHalfStar = numericValue % 1 >= 0.5;
  const uniqueId = `half-star-${Math.random().toString(36).substring(2, 11)}`;

  return (
    <div className="star-rating">
      {/* Full stars */}
      {Array.from({ length: fullStars }).map((_, index) => (
        <svg
          key={`full-${index}`}
          className="star-icon star-full"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
            fill="#FFD700"
            stroke="#FFD700"
            strokeWidth="1"
          />
        </svg>
      ))}
      
      {/* Half star */}
      {hasHalfStar && (
        <svg
          className="star-icon star-half"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <clipPath id={uniqueId}>
              <rect x="0" y="0" width="12" height="24" />
            </clipPath>
            <clipPath id={`${uniqueId}-right`}>
              <rect x="12" y="0" width="12" height="24" />
            </clipPath>
          </defs>
          {/* Left half - filled (yellow) */}
          <path
            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
            fill="#FFD700"
            stroke="#FFD700"
            strokeWidth="1"
            clipPath={`url(#${uniqueId})`}
          />
          {/* Right half - empty (gray) */}
          <path
            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
            fill="#E5E5E5"
            stroke="#E5E5E5"
            strokeWidth="1"
            clipPath={`url(#${uniqueId}-right)`}
          />
        </svg>
      )}
    </div>
  );
};

export default StarRating;

